export default {
  READY: 'ready',
  OPENED: 'opened',
  STARTED: 'started',
  SUBMITTED: 'submitted',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
};
